import React, { useEffect, useState } from "react";
import "./CookieConsent.css";

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  useEffect(() => {
    document.body.classList.toggle("cookie-open", showBanner);
    return () => document.body.classList.remove("cookie-open");
  }, [showBanner]);

  const handleConsent = (accepted) => {
    localStorage.setItem("cookie_consent", accepted ? "accepted" : "rejected");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-text">
        Wir speichern nur Ihre Entscheidung zu diesem Hinweis auf diesem Gerät.
        Es gibt keine Analyse-Cookies.{" "}
        <button
          className="cookie-link"
          onClick={() => setShowDetails(!showDetails)}
        >
          Mehr erfahren
        </button>
        {showDetails && (
          <div className="cookie-details">
            <p>
              Wir werten nicht aus, wie Sie die Seite nutzen. Die Karte im
              Kontaktbereich wird erst geladen, wenn Sie sie öffnen.
            </p>
            <p>
              Sie können der Verwendung von Cookies zustimmen oder sie ablehnen.
              Bei Fragen kontaktieren Sie uns unter:{" "}
              <a href="mailto:mfdienstleistungen@hotmail.com">
                mfdienstleistungen@hotmail.com
              </a>
            </p>
          </div>
        )}
      </div>
      <div className="cookie-buttons">
        <button className="accept-btn" onClick={() => handleConsent(true)}>
          Akzeptieren
        </button>
        <button className="reject-btn" onClick={() => handleConsent(false)}>
          Ablehnen
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
